import { Component, OnInit } from '@angular/core';
import { Observable, BehaviorSubject, Subject, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AllShipNamesService } from 'src/app/Services/all-ship-names.service';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { CruiseeventbyevtcodeService } from 'src/app/Services/cruiseeventbyevtcode.service';
import { CurrentCruiseForShipService } from 'src/app/Services/currentcruiseforship.service';
import { BookingCredentials } from '../../booking-credentials';
import { LoginService } from 'src/app/Services/login.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';

import * as moment from 'moment';
import { EmployeeData } from 'src/app/Models/employee-and-user-data';

type shipInfo = {
  FacilityId: number;
  Code: string;
  Number: string;
  Name: string;
  Type: string;
  Enabled: number;
};

type cruiseEventInfo = {
  creUid: string;
  creshpID: string;
  creshpShipName: string;
  creevtCode: string;
  creevtBegDate: any;
  creevtEndDate: any;
  creGuestCount: number;
  crePreNightCount: number;
  creDays: number;
  creevtUid: number;
  creevrTypRegionId: number;
  creItinerary: string;
  creRegion: string;
  creStartPort: string;
  creEndPort: string;
  creTheme: string;
  crefacUid: number;
};

@Component({
  selector: 'app-ship-dropdown-list',
  templateUrl: './ship-dropdown-list.component.html',
  styleUrls: ['./ship-dropdown-list.component.css'],
  providers: [
    AllShipNamesService,
    CruiseeventbyevtcodeService,
    CurrentCruiseForShipService,
    EmployeeloginService,
  ],
})
export class ShipDropdownListComponent {
  OBPortalSvcURL = '';
  busSvcURL = '';

  // userdata: UserData | undefined;

  allshipnamesdata: any;
  allshipnames: shipInfo[] = [];

  cruiseeventdata: any;
  cruiseeventfields: cruiseEventInfo[] = [];

  currentcruisedata: any;
  shipEvtCode: string | undefined;
  shipCode: any | undefined;

  public userData = {};

  LoginData: any;
  employeeData?: EmployeeData;

  constructor(
    private router: Router,
    private appConfigService: AppConfigService,
    private AllShipNamesService: AllShipNamesService,
    private CruiseeventbyevtcodeService: CruiseeventbyevtcodeService,
    private CurrentCruiseForShipService: CurrentCruiseForShipService,
    private EmployeeLoginService: EmployeeloginService,
    private loginservice: LoginService,
    private test: BookingCredentials,
  ) {}

  ngOnInit(): void {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.busSvcURL = this.appConfigService.busSvcURL;
    this.GetAllShipNames();
    this.shipCode = '';
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo == undefined) {
      this.router.navigate(['/adminlogin']);
    } else {
      this.checkLogin();
    }
  }

  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    }
  }

  GetAllShipNames() {
    this.allshipnamesdata =
      this.AllShipNamesService.GetAllShipNames().subscribe((allshipnamesdata) =>
        this.setAllShipNames(allshipnamesdata)
      );
  }
  setAllShipNames(resdata: any) {
    this.allshipnamesdata = resdata;
    if (this.allshipnamesdata.GetAllShipNames.Result.Status == 'A') {
      this.allshipnames = this.allshipnamesdata.GetAllShipNames.FacilityList;
    }
  }

  GetCruiseEventByevtCode() {
    this.cruiseeventdata =
      this.CruiseeventbyevtcodeService.GetCruiseEventByevtCode(
        this.shipEvtCode
      ).subscribe((cruiseeventdata) =>
        this.setCruiseEventByevtCode(cruiseeventdata)
      );
  }

  setCruiseEventByevtCode(resdata: any) {
    this.cruiseeventdata = resdata;
    if (this.cruiseeventdata.GetCruiseEventByevtCode.Result.Status == 'A') {
      this.cruiseeventfields =
        this.cruiseeventdata.GetCruiseEventByevtCode.CruiseEventByevtCodeList;
      //set global attributes
      this.userData = {
        evtuid: this.cruiseeventfields[0].creUid,
        evtcode: this.cruiseeventfields[0].creevtCode,
        shipid: this.cruiseeventfields[0].creshpID,
        ShipName: this.cruiseeventfields[0].creshpShipName,
        cruiseBeg: this.cruiseeventfields[0].creevtBegDate,
        cruiseEnd: this.cruiseeventfields[0].creevtEndDate,
        pckgBeg: this.cruiseeventfields[0].creevtBegDate,
        pckgEnd: this.cruiseeventfields[0].creevtEndDate,
        extended: false,
      };
      localStorage.setItem('userinfo', JSON.stringify(this.userData));
      //reroute to my day or menu

      this.router.navigate(['/menu']);
    }
  }

  GetCurrentCruiseForShip() {
    this.currentcruisedata =
      this.CurrentCruiseForShipService.GetCurrentCruiseForShip(
        this.shipCode
      ).subscribe((currentcruisedata) =>
        this.setCurrentCruiseForShip(currentcruisedata)
      );
  }

  setCurrentCruiseForShip(resdata: any) {
    this.currentcruisedata = resdata;
    if (this.currentcruisedata.GetCurrentCruiseForShip.Result.Status == 'A') {
      this.shipEvtCode =
        this.currentcruisedata.GetCurrentCruiseForShip.CruiseCode;
      this.GetCruiseEventByevtCode();
    }
  }
}
